import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';
import { CreditCardGatewayService } from '../shared/credit-card-gateway/credit-card-gateway.service';
import { TransactionSummarySearchDto } from '../shared/transaction/transaction-summary-search.dto';
import { FinancialServiceService } from '../shared/financial.service';
import { ArbCreationActivityDto } from '../shared/dto/arb-creation-activity';

@Component({
  selector: 'wl-arbcreation',
  templateUrl: './arbcreation.component.html',
  styleUrls: ['./arbcreation.component.less'],
    standalone: false
})
export class ArbcreationComponent {
  searchParams: TransactionSummarySearchDto;
  searchResult: Array<ArbCreationActivityDto>;
  creditCardGateways: Array<SelectItem>;
  busy = false;
  pageSize = 20;
  first = 0;
  exporting: boolean;

  constructor(
    public securityElementNames: SecurityElementNames,
    private _ccGateWayService: CreditCardGatewayService,
    private _financialService: FinancialServiceService
  ) {
    let startDate = new Date();
    new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDay());
    this.searchParams = { StartDate: startDate } as TransactionSummarySearchDto;
    this.searchResult = [];
    this.creditCardGateways = [];
  }

  ngOnInit(): void {
    this._ccGateWayService.getAllCreditCardGateways().then((data) => {
      this.creditCardGateways = data.map((x) => {
        return { label: x.Name, value: x.CCGatewayID };
      });
    });
  }

  search() {
    this.busy = true;
    this._financialService
      .getArbCreationActivity(this.searchParams)
      .then((data) => {
        this.searchResult = data.Result;
        this.first = 0;
      })
      .finally(() => {
        this.busy = false;
      });
  }

  clear() {
    this.searchResult = [];
  }
}
